import { IControlViewModel, ICardModel, ICardUIExtensionContext, CardUIExtension } from "tessa/ui/cards";
import { DotNetType, createTypedField, Visibility, Guid, TypedField } from "tessa/platform";
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';
import { Card, CardFieldChangedEventArgs, CardRow, CardRowState, FieldMapStorage } from 'tessa/cards';
import { CardRequest, CardService } from "tessa/cards/service";
import { CdRequestTypes } from "src/cdScripts/Helpers/CdRequestTypes";
import { showError, showNotEmpty } from "tessa/ui";
import { AutoCompleteEntryViewModel, CheckBoxViewModel, GridRowAction, GridViewModel, LabelViewModel, TextBoxViewModel } from "tessa/ui/cards/controls";
import { PkCommonHelper } from "src/pkScripts/Helpers/PkCommonHelper";
import { CdUIHelper } from "../CdUIHelper";
import { PkClientHelper } from 'src/pkScripts/Helpers/PkClientHelper';
import { isNullOrUndefined } from "util";
import { ValidationResult, ValidationResultType } from "tessa/platform/validation";
import { CdCommonHelper } from "src/cdScripts/Helpers/CdCommonHelper";


export class CdAdditionalWorksContractOrderUIExtension extends CardUIExtension {

    private _disposer: Function | null = null;

    public async initialized(context: ICardUIExtensionContext) {
        let model: ICardModel;
        let card: Card;
        if ((model = context.model) == null || (card = context.model.card) == null) {
            return;
        }

        if (!Guid.equals(card.typeId, CdCardTypes.PkAdditionalWorksContractOrderTypeID)) {
            return;
        }
        // Костыль для перехода по гирерссылке в эл-те управления "метка". В толстом работает из коробки, в вебе нет
        let linkToGuide1 = model.controls.get('linkToGuide1') as LabelViewModel;
        linkToGuide1.onClick = () => {
            window.open("https://disk.yandex.ru/i/gXZWoSDxdAszzA", '_blank');
        };

        // Обработка чек-бокса "Расчет сделан не в КЦ" 
        this.HandleIsOutsideKcCalculationFlag(model, card);

        // Обработка изменений в поле "ID расчета стоимости работ (ПДЦ)"
        await this.HandleOnPdcNumberChangedAsync(card);

        // Обработка при выборе объекта
        await this.HandleOnObjectChangedAsync(card);

        // Заполнение ЖК при выборе объекта
        // await this.FillLivingComplexWhenObjectChanged(card);

        // Обработка изменений в поле "Событие" в таблице "Список РВР".
        this.HandleRvrListChanges(context, card);

        // Обработка изменений в таблице "Состав доп. работ".
        this.HandleRvrWorksChanges(card);

        // пересчет суммы и процентов в блоке РВР
        this.RecalcTotalRvrAmount(card);

        // Обработка изменений в таблице "Распределение сумм по виновным (электронный АРФО)"
        this.HandleRvrGuiltyChanges(card);

        // Обработка поля "Виновный участник" при заполнении таблицы "Список виновных для АРФО"
        await this.HandleGuiltyPartiesRowEvents(context, card);

        // Блокирование/разблокирование блока "Основная информация" в зависимости от флага AllowChangeKc
        this.CheckAllowChangeKcMode(context, card);
    }
    private CheckAllowChangeKcMode(context: ICardUIExtensionContext, card: Card) {
        // Если значение флага AllowChangeKc = false, то все элементы управления блока "Основная информация" должны быть недоступны для редактирования
        let AllowChangeKc: boolean | undefined = this.AllowChangeKc(card);
        if (AllowChangeKc === undefined || AllowChangeKc === null || AllowChangeKc === true) {
            return;
        }
        let block = context.model.blocks.get("BlockMain");
        if (!block) return;
        for (let control of block.controls) {
            control.isReadOnly = true;
        }
    }


    private AllowChangeKc(card: Card): boolean | undefined {
        var order = card.sections.get("PkAdditionalWorksContractOrder");
        if (order) {
            return order.fields.tryGet("AllowChangeKc");
        }
        return undefined;
    }

    /** Обработка флага "Наличие спец. работ". **/
    private HandleIsOutsideKcCalculationFlag(model: ICardModel, card: Card) {

        // Чек-бокс "Расчет сделан не в КЦ" - если данный чек-бокс заполнен, то поле с вводом ID расчета ПДЦ скрываем с формы.

        let isOutsideKcCalculationControl: IControlViewModel | undefined = model.controls.get('IsOutsideKcCalculation');
        let awcoSection = card.sections.tryGet('PkAdditionalWorksContractOrder');

        if (awcoSection && isOutsideKcCalculationControl) {

            let isOutsideKcCalculation: boolean | undefined = awcoSection.fields.tryGet('IsOutsideKcCalculation');
            this.CheckOutsideKcCalculation(model, isOutsideKcCalculation);

            awcoSection.fields.fieldChanged.add(e => {
                if (e.fieldName === 'IsOutsideKcCalculation') {
                    let isOutsideKcCalculation = e.fieldValue;
                    this.CheckOutsideKcCalculation(model, isOutsideKcCalculation);
                }
            });
        }
    }

    /* Устанавливает доступность эл-тов управления в зависимости от флага  "Расчет сделан не в КЦ" */
    private CheckOutsideKcCalculation(model: ICardModel, isOutsideKcCalculation: boolean | undefined) {
        if (isOutsideKcCalculation === undefined) {
            isOutsideKcCalculation = false;
        }

        // Если isOutsideKcCalculation = true, то поле с вводом ID расчета ПДЦ скрываем с формы и делаем доступными поля "Общая стоимость из ПДЦ", "Объект",  "Исполнитель". Иначе наоборот
        let pdcNumberControl: IControlViewModel | undefined = model.controls.get('PdcNumber');
        pdcNumberControl!.controlVisibility = isOutsideKcCalculation ? Visibility.Collapsed : Visibility.Visible;

        // Если контрол "Расчет сделан не в КЦ" ридонли, то поля "Общая стоимость из ПДЦ",  "Объект",  "Исполнитель" тоже делаем ридонли.
        let isOutsideKcCalculationModel: IControlViewModel | undefined = model.controls.get('IsOutsideKcCalculation');
        let isControlBlockReadOnly: boolean | undefined = !isOutsideKcCalculation || isOutsideKcCalculationModel!.isReadOnly;


        // Если поле с вводом ID расчета ПДЦ срыто, то поля "Общая стоимость из ПДЦ",  "Объект",  "Исполнитель" доступны для редактирования. Иначе нет
        let ctrlAmountFromPdc: IControlViewModel | undefined = model.controls.get('AmountFromPdc');
        ctrlAmountFromPdc!.isReadOnly = isControlBlockReadOnly;

        let ctrlPerformer: IControlViewModel | undefined = model.controls.get('Performer');
        ctrlPerformer!.isReadOnly = isControlBlockReadOnly;

        let ctrlObject: IControlViewModel | undefined = model.controls.get('Object');
        ctrlObject!.isReadOnly = isControlBlockReadOnly;

        let ctrlStartWorkDateFromKC: IControlViewModel | undefined = model.controls.get('StartWorkDateFromKC');
        ctrlStartWorkDateFromKC!.isReadOnly = isControlBlockReadOnly;

        let ctrlFinishWorkDateFromKC: IControlViewModel | undefined = model.controls.get('FinishWorkDateFromKC');
        ctrlFinishWorkDateFromKC!.isReadOnly = isControlBlockReadOnly;

        // Если флажок установлен, то очищаем поле "ID расчета ПДЦ"
        if (isOutsideKcCalculation) {
            let section = model.card.sections.tryGet("PkAdditionalWorksContractOrder");
            section!.fields.set("PdcNumber", null);
        }

    }

    /** Обработка изменений в поле "ID расчета стоимости работ (ПДЦ)" **/
    private async HandleOnPdcNumberChangedAsync(card: Card) {

        let section = card.sections.tryGet("PkAdditionalWorksContractOrder");
        if (isNullOrUndefined(section)) {
            return;
        }

        section.fields.fieldChanged.add(async e => {
            if (e.fieldName === 'PdcNumber') {

                if (isNullOrUndefined(e.fieldValue)) {
                    return;
                }

                let sectionDci = card.sections.tryGet("DocumentCommonInfo");
                let sectionRdp = card.sections.tryGet("PkRdProperties");

                sectionDci!.fields.set("Amount", null);
                section!.fields.set("StartWorkDate", null);
                section!.fields.set("FinishWorkDate", null);
                sectionRdp!.fields.set("ObjectID", null);
                sectionRdp!.fields.set("ObjectName", null);
                section!.fields.set("PerformerID", null);
                section!.fields.set("PerformerName", null);
                section!.fields.set("PerformerExternalID", null);
                section!.fields.set("Performer_INN", null);


                // Если "ID расчета стоимости работ (ПДЦ)" выбрано, то запрвщиваем и заполняем поля "Общая стоимость из ПДЦ",  "Объект",  "Исполнитель"
                await this.FillDataByPdcAsync(card, e.fieldValue);
            }
        });
    }

    private async FillDataByPdcAsync(card: Card, pdcNumber: string) {
        if (isNullOrUndefined(pdcNumber)) {
            return;
        }

        const request = new CardRequest();
        request.requestType = CdRequestTypes.GetInfoByPdc;
        request.info["PdcNumber"] = createTypedField(pdcNumber, DotNetType.String);
        request.info["FieldRoleType"] = createTypedField(0, DotNetType.Int32);

        const response = await CardService.instance.request(request);

        await showNotEmpty(response.validationResult.build());
        if (!response.validationResult.isSuccessful) {
            return;
        }

        let sectionDci = card.sections.tryGet("DocumentCommonInfo");
        // "Общая стоимость из ПДЦ"
        sectionDci!.fields.set("Amount", response.info.Amount);

        // "Объект"
        let sectionRdp = card.sections.tryGet("PkRdProperties");
        sectionRdp!.fields.set("ObjectID", response.info.ObjectID);
        sectionRdp!.fields.set("ObjectName", response.info.ObjectName);

        // "Исполнитель"
        let sectionAwco = card.sections.tryGet("PkAdditionalWorksContractOrder");
        sectionAwco!.fields.set("PerformerID", response.info.PerformerID);
        sectionAwco!.fields.set("PerformerName", response.info.PerformerName);
        sectionAwco!.fields.set("PerformerExternalID", response.info.PerformerExternalID);
        sectionAwco!.fields.set("PerformerINN", response.info.PerformerINN);
        sectionAwco!.fields.set("Performer_INN", response.info.PerformerINN);

        // Даты
        sectionAwco!.fields.set("StartWorkDate", response.info.StartWorkDateFromKC);
        sectionAwco!.fields.set("FinishWorkDate", response.info.FinishWorkDateFromKC);

    }

    /* Обработка при выборе объекта. */
    private async HandleOnObjectChangedAsync(card: Card) {

        let section = card.sections.tryGet('PkRdProperties');
        if (isNullOrUndefined(section)) {
            return;
        }
        section.fields.fieldChanged.add(async e => {
            if (e.fieldName === 'ObjectID') {
                let objectId = e.fieldValue;

                section!.fields.set("ObjectPlaceID", null);
                section!.fields.set("ObjectPlaceLivingComplex", null);

                if (isNullOrUndefined(objectId)) {
                    return
                }
                // Заполняем ЖК  
                const request = new CardRequest();
                request.requestType = CdRequestTypes.GetRdDivisionRoleProperties;
                request.info["FieldID"] = createTypedField(objectId, DotNetType.Guid);
                request.info["FieldRoleType"] = createTypedField(0, DotNetType.Int32);

                const response = await CardService.instance.request(request);

                await showNotEmpty(response.validationResult.build());
                if (!response.validationResult.isSuccessful) {
                    return;
                }

                section!.fields.set("ObjectPlaceID", response.info.ResidentialComplexID);
                section!.fields.set("ObjectPlaceLivingComplex", response.info.ResidentialComplexName);

                // Очищаем таблицу "Список РВР"
                const clearTable = (name: string) => {
                    const rows = card.sections.get(name)!.rows;
                    const removeRows = rows.filter(x => x.state === CardRowState.Inserted);
                    for (let row of removeRows) {
                        rows.remove(row);
                    }
                    for (let row of rows) {
                        row.state = CardRowState.Deleted;
                    }
                };

                // болк "Список РВР" очищается, если значение флага AllowChangeKc != true
                let AllowChangeKc: boolean | undefined = this.AllowChangeKc(card);
                if (AllowChangeKc === undefined || AllowChangeKc === null || AllowChangeKc === false) {
                    clearTable("PkAdditionalWorksContractOrderRvrGuilty");
                    clearTable("PkAdditionalWorksContractOrderRvrWorks");
                    clearTable("PkAdditionalWorksContractOrderRvrList");
                }
                // Очистим сумму в поле "Из них РВР"
                this.RecalcTotalRvrAmount(card);

            }
        });


    }

    /**   Обработка изменений в поле "Событие" в таблице "Список РВР".  **/
    private HandleRvrListChanges(context: ICardUIExtensionContext, card: Card) {

        var rvrList = card.sections.tryGet('PkAdditionalWorksContractOrderRvrList');
        if (isNullOrUndefined(rvrList)) {
            return;
        }

        const rvrListChangeHandler = (e: CardFieldChangedEventArgs) => {
            if (isNullOrUndefined(e)) {
                return;
            }

            let row = e.storage;
            if (isNullOrUndefined(row)) {
                return;
            }

            if (e.fieldName == "ARFOEventID") {
                row.set('ARFOIssueReasonID', null);
                row.set('ARFOIssueReasonName', null);
                row.set('ARFOIssueReasonCode', null);
                row.set('ARFOIssueReasonActivityType', null);
                row.set('ARFOIssueReason_ActivityType', null);
            }

            if (e.fieldName == "ARFOIssueReasonCode") {

                let rowId = row.get("RowID");

                // Очистим виновных по строке РВР
                let tableRvrGuilty = card.sections.tryGet("PkAdditionalWorksContractOrderRvrGuilty");
                if (!isNullOrUndefined(tableRvrGuilty)) {
                    for (let i = tableRvrGuilty.rows.length - 1; i >= 0; i--) {

                        let row = tableRvrGuilty!.rows[i];
                        let parentRvrRowID = row.get("ParentRvrRowID");
                        if (rowId == parentRvrRowID) {
                            if (row.state === CardRowState.Inserted) {
                                tableRvrGuilty.rows.remove(row);
                            }
                            row.state = CardRowState.Deleted;
                        }
                    }
                }

                // Проверим особый случай заполнения таблицы виновных
                this.CheckIssueReasonCodeSpecialCase(card, row);

                // Общую сумму по всем РВР запишем в поле "Из них РВР"
                this.RecalcTotalRvrAmount(card);
            }
        };

        PkClientHelper.SubscribeForFieldChanging(rvrList, rvrListChangeHandler);


        // Проверка заполнения обязательных полей в форме "РВР"
        const rvrListEditor = context.model.controls.get('RvrTable') as GridViewModel;
        if (rvrListEditor == null) { return; }
        rvrListEditor.rowValidating.add(e => {

            if (e.row.tryGet("KeySectionNERID") == null) {
                e.validationResult.add(ValidationResult.fromText("Необходимо заполнить поле \"Ключевой раздел НЭР\".", ValidationResultType.Error));
            }

            if (e.row.tryGet("ARFOEventID") == null) {
                e.validationResult.add(ValidationResult.fromText("Необходимо заполнить поле \"Событие\".", ValidationResultType.Error));
            }

            if (e.row.tryGet("ARFOIssueReasonID") == null) {
                e.validationResult.add(ValidationResult.fromText("Необходимо заполнить поле \"Причина возникновения события\".", ValidationResultType.Error));
            }

            if (e.row.tryGet("StartWorkDate") == null) {
                e.validationResult.add(ValidationResult.fromText("Необходимо заполнить поле \"Дата начала работ\".", ValidationResultType.Error));
            }

            if (e.row.tryGet("WorksJustification") == null || e.row.tryGet("WorksJustification").trim() == "") {
                e.validationResult.add(ValidationResult.fromText("Необходимо заполнить поле \"Обоснование необходимости работ (цепочка событий)\".", ValidationResultType.Error));
            }

 
            // Проверка значений дат начала и окончания работ
            let dateStart = e.row.tryGet("StartWorkDate");
            let finishDate = e.row.tryGet("FinishWorkDate");
            if (dateStart && finishDate) {
                if (dateStart > finishDate) {
                    e.validationResult.add(ValidationResult.fromText("\"Дата начала работ\" должна быть меньше или равна \"Дате окончания работ\"", ValidationResultType.Error));
                }
            }

            let sectionMain = card.sections.tryGet('PkAdditionalWorksContractOrder');
            let startWorkDateFromKC = sectionMain?.fields.tryGet('StartWorkDate');
            let finishWorkDateFromKC = sectionMain?.fields.tryGet('FinishWorkDate');
            if (dateStart && startWorkDateFromKC && dateStart < startWorkDateFromKC) {
                e.validationResult.add(ValidationResult.fromText("\"Дата начала работ\" для Ключевого раздела НЭР должна быть больше или равна \"Дата начала работ (из Расчета КЦ)\" по объекту.", ValidationResultType.Error));
            }

            if (finishDate && finishWorkDateFromKC && finishDate > finishWorkDateFromKC) {
                e.validationResult.add(ValidationResult.fromText("\"Дата окончания работ\" для Ключевого раздела НЭР должна быть меньше или равна \"Дата окончания работ (из Расчета КЦ)\" по объекту.", ValidationResultType.Error));
            }

            if (finishWorkDateFromKC && dateStart && dateStart > finishWorkDateFromKC) {
                e.validationResult.add(ValidationResult.fromText("\"Дата начала работ\" для Ключевого раздела НЭР должна быть меньше или равна \"Дата окончания работ (из Расчета КЦ)\" по объекту.", ValidationResultType.Error));
            }

            if (startWorkDateFromKC && finishDate && finishDate < startWorkDateFromKC) {
                e.validationResult.add(ValidationResult.fromText("\"Дата окончания работ\" для Ключевого раздела НЭР должна быть больше или равна \"Дата начала работ (из Расчета КЦ)  по объекту.", ValidationResultType.Error));
            }
        });

    }

    /** Обработка изменений в таблице "Состав доп. работ". **/
    private HandleRvrWorksChanges(card: Card) {

        let rvrWorkList = card.sections.tryGet('PkAdditionalWorksContractOrderRvrWorks');

        const rvrWorksChangeHandler = (e: CardFieldChangedEventArgs) => {
            if (isNullOrUndefined(e)) {
                return;
            }

            let row = e.storage;
            if (isNullOrUndefined(row)) {
                return;
            }

            let rvrList = card.sections.tryGet('PkAdditionalWorksContractOrderRvrList');
            rvrList!.rows.forEach(rvrRow => {
                if (rvrRow.state != CardRowState.Deleted) {

                    let rvrWorks = card.sections.tryGet('PkAdditionalWorksContractOrderRvrWorks');
                    let rvrAmount = parseFloat("0.0");

                    rvrWorks!.rows.forEach(workRow => {
                        if (workRow.state != CardRowState.Deleted && rvrRow.tryGet("RowID") == workRow.tryGet("ParentRvrRowID")) {
                            let workAmount: number = workRow.tryGet("Amount") ? Number(workRow.tryGet("Amount") || 0.0) : 0.0;
                            rvrAmount = rvrAmount + workAmount;
                        }
                    });

                    //const amt = createTypedField(parseFloat((Math.round(rvrAmount * 100) / 100).toFixed(2)), DotNetType.Decimal);
                    rvrRow.set("Amount", this.DecimalFieldValue(rvrAmount));

                    // При изменении суммы проверим состояние строки в дочерней таблице виновных в зависимости от кода причины
                    this.UpdateGuiltyAmountIfSpecialCase(card, rvrRow);
                }
            });

            // Общую сумму по всем РВР запишем в поле "Из них РВР"
            this.RecalcTotalRvrAmount(card);
        };
        PkClientHelper.SubscribeForFieldChanging(rvrWorkList!, rvrWorksChangeHandler);
    }

    private HandleRvrGuiltyChanges(card: Card) {
        var rvrGuilty = card.sections.tryGet('PkAdditionalWorksContractOrderRvrGuilty');
        if (isNullOrUndefined(rvrGuilty)) {
            return;
        }

        const rvrGuiltyChangeHandler = async (e) => {
            if (isNullOrUndefined(e) || e.fieldName == "GuiltDegreePercentage") {
                return;
            }
            if (isNullOrUndefined(e) || e.fieldName == "GuiltyPartyCriteriaString") {
                return;
            }
            
            if (e.fieldName == "GuiltyPartyExternalID") {
                let row = e.storage;
                let partnerExternalID = e.fieldValue;
                let synonymAlias = await this.GetPartnerSynonymAliasByExternalID(partnerExternalID);
                  
                if (synonymAlias === null || synonymAlias === undefined) {
                    CdCommonHelper.SetFieldToRow(row, "GuiltyPartyCriteriaString", createTypedField(row.get("GuiltyPartyName"), DotNetType.String));
                }
                else {
                    CdCommonHelper.SetFieldToRow(row, "GuiltyPartyCriteriaString", createTypedField(synonymAlias, DotNetType.String));
                }
            }

            this.RecalcGuiltDegreePercentage(card);
        };

        PkClientHelper.SubscribeForFieldChanging(rvrGuilty, rvrGuiltyChangeHandler);
    }
    private async GetPartnerSynonymAliasByExternalID(partnerExternalID : number | null) {
        if (partnerExternalID === null || partnerExternalID === undefined) {
            return null;
        }

        const request = new CardRequest();
        request.requestType = CdRequestTypes.GetPartnerSynonymAliasByExternalID;
        request.info["PartnerExternalID"] = createTypedField(partnerExternalID, DotNetType.Int64);
     

        const response = await CardService.instance.request(request);
        if (!response.validationResult.isSuccessful)
            return null;

        let error = response.info.Error?.$value;
        if (error) {
            await showError(error);
            return null;
        }

        let res: string = response.info.Alias.$value;
        return res;
    }

    /** Обработка поля "Виновный участник" при заполнении таблицы "Список виновных для АРФО". **/
    private async HandleGuiltyPartiesRowEvents(context: ICardUIExtensionContext, card: Card) {

        const gkPikPerimetrName = "ГруппаКомпанийПИК"; // todo: kill hardcode

        let rvrTable = CdUIHelper.GetUIControlFromForm<GridViewModel>(context.model.mainForm!, "RvrTable");
        rvrTable!.rowInitializing.add(e => {

            // TES-8278 поля "Дата начала работ", "Дата окончания работ" по умолчанию заполнить значениями полей "Дата начала работ (из Расчета КЦ)", "Дата окончания работ (из Расчета КЦ)"
            if (e.action == GridRowAction.Inserted) {
                let sectionMain = card.sections.tryGet('PkAdditionalWorksContractOrder');
                let startWorkDate = sectionMain?.fields.tryGet('StartWorkDate');
                if (startWorkDate) {
                    e.row.set('StartWorkDate', createTypedField(startWorkDate, DotNetType.DateTime));
                }
                let finishWorkDate = sectionMain?.fields.tryGet('FinishWorkDate');
                if (finishWorkDate) {
                    e.row.set('FinishWorkDate', createTypedField(finishWorkDate, DotNetType.DateTime));
                }
            }

            let rvrTableBlock = e.rowModel?.blocksBag.find(x => x.name == "RvrTableBlock");
            var ctrlRvrRowARFOIssueReason = CdUIHelper.GetUIControlFromForm<AutoCompleteEntryViewModel>(rvrTableBlock?.form!, "RvrRowARFOIssueReason");
            let rvrTableRowGuiltTable = CdUIHelper.GetUIControlFromForm<GridViewModel>(rvrTableBlock?.form!, "RvrTableRowGuiltTable");

            if (!rvrTableRowGuiltTable) {
                return;
            }

            const checkCode = (code: string) => {
                let guiltyName = this.GetGuiltyNameBySpecialCase(code)
                if (!PkCommonHelper.IsNullOrWhitespace(guiltyName)) {
                    this.CheckIssueReasonCodeSpecialCase(card, e.row);
                    rvrTableRowGuiltTable!.controlVisibility = Visibility.Collapsed;
                }
                else {
                    rvrTableRowGuiltTable!.controlVisibility = Visibility.Visible;
                }
            };

            let code = ctrlRvrRowARFOIssueReason!.hasEmptyValue ? "" : ctrlRvrRowARFOIssueReason!.item!.columnValues[1] as string;
            checkCode(code);
            ctrlRvrRowARFOIssueReason!.valueSet.add((ev) => {
                checkCode(ev.item!.columnValues[1] as string);
            });

            ctrlRvrRowARFOIssueReason!.valueDeleted.add(() => {
                checkCode("");
            });

            rvrTableRowGuiltTable!.rowValidating.add(async e => {

                // Проверка заполнения обязательных полей
                if (e.row.tryGet("GuiltyPartyID") == null) {
                    e.validationResult.add(ValidationResult.fromText("Необходимо заполнить поле \"Виновный участник\".", ValidationResultType.Error));
                }

                if (this.IsNullOrZerro(e.row.tryGet("CompensationAmount"))) {
                    e.validationResult.add(ValidationResult.fromText("Необходимо заполнить поле \"Сумма компенсации\".", ValidationResultType.Error));
                }

                // Комментарий - пользователь заполняет вручную при создании или редактировании данной строчки таблицы. Если в данной строчке стоит флаг "Перевыставлении затрат" и "Пакет документов для претензии" не стоит, то поле комментарий должно быть обязательно заполнено хотя бы 3 символами
                var isExpensesRechargeVm = e?.rowModel?.controls.get('IsExpensesRecharge') as CheckBoxViewModel;
                const isClaimDocPackageVm = e?.rowModel?.controls.get('IsClaimDocPackage') as CheckBoxViewModel;
                const commentaryVm = e?.rowModel?.controls.get('Commentary') as TextBoxViewModel;

                if (isExpensesRechargeVm.isChecked) {

                    if (!isClaimDocPackageVm.isChecked) {
                        var comment = commentaryVm.text;
                        if (PkCommonHelper.IsNullOrWhitespace(comment) || comment.length < 3) {
                            e.validationResult.add(ValidationResult.fromText("При перевыставлении затрат, если не выставлен флажок \"Намерение по перевыставлению\", то необходимо заполнить поле \"Комментарий\" (не менее 3-х символов).", ValidationResultType.Error));
                        }
                    }
                }

                // TES-6190 п.12. При проставлен чек-бокс "Пакет документов для претензии", то обязательна должно быть заполнено поле Номер договора (с виновными). Если чек-бокс не проставлен, то данное поле не заполняется (залочено, заблокировано для заполнения).
                var ctrlContract = e?.rowModel?.controls.get("Contract") as AutoCompleteEntryViewModel;
                if (isClaimDocPackageVm.isChecked) {
                    if (ctrlContract != null && ctrlContract.hasEmptyValue) {
                        e.validationResult.add(ValidationResult.fromText("Если проставлен чек-бокс \"Намерение по перевыставлению\", то обязательна должно быть заполнено поле \"Договор по объекту\".", ValidationResultType.Error));
                    }
                }
                // при любом изменении таблицы пересчитаваем сумму и проценты
                this.RecalcTotalRvrAmount(card);
            });

            // ВГО - чек-бокс заполняется автоматически на основании того, какой подрядчик был выбран.
            // Если выбрали организацию, которая связана с партнером, который входит в периметр "ГруппаКомпанийПИК",
            // то проставляется, если же не входит в такой периметр или вообще ни в один не входит, то чек-бокс пустой 
            rvrTableRowGuiltTable.rowInvoked.add(async (e) => {
                if (!e.rowModel) {
                    return;
                }

                if (e.action == GridRowAction.Opening || e.action == GridRowAction.Inserted) {
                    e.row.fieldChanged.add(async e2 => {
                        //При изменении занчения в поле GuiltyPartyExternalID       
                        if (e2.fieldName === "GuiltyPartyExternalID") {

                            let externalID = e2.fieldValue;

                            // Проверим, в периметре ли участник
                            let isInPerimeter = await this.CheckPartnerInPerimeterAsync(externalID, gkPikPerimetrName);

                            // Установим значения полей "ВГО" и "Перевыставление затрат"
                            e.row.set('IsVGO', createTypedField(isInPerimeter, DotNetType.Boolean));


                            // Логика отметки "перевыставление"
                            //   чек-бокс НЕ заполнен, если: 
                            //   Вариант 1 - подрядчик относится к ВГО
                            //   Вариант 2- (подрядчик НЕ относится к ВГО) + (код выбранной в карточке "причине возникновения события" =  1.6 или  1.8 или  1.12 или 1.13)
                            //   В остальных случаях чек-бокс "перевыставление затрат" будет заполнен
                            let isExpensesRecharge = !isInPerimeter; //  подрядчик относится к ВГО
                            if (!isInPerimeter) // подрядчик НЕ относится к ВГО
                            {
                                let awcoSection = card.sections.tryGet('PkAdditionalWorksContractOrder');
                                if (awcoSection) {
                                    let issueReasonCode: string | undefined = awcoSection.fields.tryGet('ARFOIssueReasonCode');
                                    if (issueReasonCode) {
                                        if (!PkCommonHelper.IsNullOrWhitespace(issueReasonCode)) {
                                            isExpensesRecharge = !(
                                                issueReasonCode.startsWith('1.6')
                                                || issueReasonCode.startsWith('1.8')
                                                || issueReasonCode.startsWith('1.12')
                                                || issueReasonCode.startsWith('1.13')
                                            );
                                        }
                                    }
                                }
                            }
                            e.row.set('IsExpensesRecharge', createTypedField(isExpensesRecharge, DotNetType.Boolean));
                        }
                    });
                }

                // при любом изменении таблицы пересчитаваем сумму и проценты
                this.RecalcTotalRvrAmount(card);

            });

            // Проверка заполнения обязательных полей в форме "Состав доп. работ"
            let rvrTableRowWorksTable = CdUIHelper.GetUIControlFromForm<GridViewModel>(rvrTableBlock?.form!, "RvrTableRowWorksTable");
            rvrTableRowWorksTable!.rowValidating.add(async e => {
                if (e.row.tryGet("WorkKindID") == null) {
                    e.validationResult.add(ValidationResult.fromText("Необходимо заполнить поле \"Вид работ\".", ValidationResultType.Error));
                }

                if (this.IsNullOrZerro(e.row.tryGet("Amount"))) {
                    e.validationResult.add(ValidationResult.fromText("Необходимо заполнить поле \"Сумма\".", ValidationResultType.Error));
                }

                if (e.row.tryGet("CostItemID") == null) {
                    e.validationResult.add(ValidationResult.fromText("Необходимо заполнить поле \"Статья затрат\".", ValidationResultType.Error));
                }
            });


        });
    }
        
    private RecalcTotalRvrAmount(card: Card) {
        // По списку работ расчитываем общую сумму "Из них РВР"
        // Запишем в поле "Из них РВР"
        var order = card.sections.tryGet('PkAdditionalWorksContractOrder');

        let amount: number = this.GetTotalRvrAmount(card);

        order!.fields.set("RvrAmount", this.DecimalFieldValue(amount));

        // Пересчитаем проценты для каждой строки в списке виновных
        this.RecalcGuiltDegreePercentage(card);
    }

    private RecalcGuiltDegreePercentage(card: Card) {
        var rvrGuilty = card.sections.tryGet('PkAdditionalWorksContractOrderRvrGuilty');
        if (isNullOrUndefined(rvrGuilty)) {
            return;
        }
        let rvrList = card.sections.tryGet('PkAdditionalWorksContractOrderRvrList');
        if (isNullOrUndefined(rvrList)) {
            return;
        }

        // Пересчитаем проценты для каждой строки в списке виновных
        rvrGuilty.rows.forEach(row => {
            if (row.state != CardRowState.Deleted) {

                let parentRvrRowID = row.get("ParentRvrRowID");
                let total: number = this.GetRvrAmount(card, parentRvrRowID);
                let value = row.tryGet("CompensationAmount") ? Number(row.tryGet("CompensationAmount") || 0.0) : 0.0;
                let percent = (total === 0) ? 0.00 : (value / total) * 100.00;
                let percentRounded = Math.round((percent + Number.EPSILON) * 100) / 100;
                row.set("GuiltDegreePercentage", this.DecimalFieldValue(percentRounded));
            }
        });
    }

    private DecimalFieldValue(value: number): TypedField<DotNetType.Decimal, string> {
        let val: string = (Math.round(value * 100) / 100).toFixed(2).toString().replace(',', '.');
        return createTypedField(val, DotNetType.Decimal);
    }

    private GetTotalRvrAmount(card: Card): number {
        let total: number = 0.0;
        let rvrList = card.sections.tryGet('PkAdditionalWorksContractOrderRvrList');
        if (isNullOrUndefined(rvrList)) {
            return total;
        }
        rvrList.rows.forEach(row => {
            if (row.state != CardRowState.Deleted) {

                let amount = row.tryGet("Amount") ? Number(row.tryGet("Amount") || 0.0) : 0.0;
                total += amount;
            }
        });

        return total;
    }

    private GetRvrAmount(card: Card, parentRvrRowID: any): number {
        let rvrList = card.sections.tryGet('PkAdditionalWorksContractOrderRvrList');
        if (isNullOrUndefined(rvrList)) {
            return 0.00;
        }
        const rvrRow = rvrList?.rows.find(x => x.rowId == parentRvrRowID);
        if (isNullOrUndefined(rvrRow)) {
            return 0.00;
        }
        return rvrRow.tryGet("Amount") ? Number(rvrRow.tryGet("Amount") || 0.0) : 0.0;
    }

    private UpdateGuiltyAmountIfSpecialCase(card: Card, rvrRow: FieldMapStorage) {
        let code: string = rvrRow.tryGet("ARFOIssueReasonCode");

        let guiltyPartyName: string | undefined = this.GetGuiltyNameBySpecialCase(code);
        if (isNullOrUndefined(guiltyPartyName!)) {
            return;
        }

        let tableRvrGuilty = card.sections.tryGet("PkAdditionalWorksContractOrderRvrGuilty");
        if (isNullOrUndefined(tableRvrGuilty)) {
            return;
        }
        let rowId = rvrRow.get("RowID");
        let amount: number | undefined = rvrRow.tryGet("Amount") ? Number(rvrRow.tryGet("Amount") || 0.0) : 0.0;

        for (let i = tableRvrGuilty.rows.length - 1; i >= 0; i--) {
            let row = tableRvrGuilty!.rows[i];
            let parentRvrRowID = row.get("ParentRvrRowID");
            let rowGuiltyPartyName = row.get("GuiltyPartyName");
            if (rowId == parentRvrRowID && guiltyPartyName == rowGuiltyPartyName) {
                row.set("CompensationAmount", this.DecimalFieldValue(amount));
            }
        }
    }

    private CheckIssueReasonCodeSpecialCase(card: Card, rvrRow: FieldMapStorage) {
        let code: string = rvrRow.tryGet("ARFOIssueReasonCode");
        let amount: number | undefined = rvrRow.tryGet("Amount") ? Number(rvrRow.tryGet("Amount") || 0.0) : 0.0;
        let guiltyPartyName: string | undefined = this.GetGuiltyNameBySpecialCase(code);
        let rowId = rvrRow.get("RowID");

        if (!isNullOrUndefined(guiltyPartyName!)) {
            // Очистим виновных по строке РВР
            let tableRvrGuilty = card.sections.tryGet("PkAdditionalWorksContractOrderRvrGuilty");
            if (!isNullOrUndefined(tableRvrGuilty)) {
                for (let i = tableRvrGuilty.rows.length - 1; i >= 0; i--) {
                    let row = tableRvrGuilty!.rows[i];
                    let parentRvrRowID = row.get("ParentRvrRowID");
                    if (rowId == parentRvrRowID) {
                        if (row.state === CardRowState.Inserted) {
                            tableRvrGuilty.rows.remove(row);
                        }
                        row.state = CardRowState.Deleted;
                    }
                }
            }

            // Добавим фейковую строку
            let rvrGuiltyRow = new CardRow();
            rvrGuiltyRow.rowId = Guid.newGuid();
            rvrGuiltyRow.set("ParentRvrRowID", createTypedField(rowId, DotNetType.Guid));
            rvrGuiltyRow.set("ContractID", null);
            rvrGuiltyRow.set("ContractNameVirtual", null);
            rvrGuiltyRow.set("CompensationAmount", amount, DotNetType.String);
            rvrGuiltyRow.set("GuiltDegreePercentage", this.DecimalFieldValue(100.00));
            rvrGuiltyRow.set("GuiltyPartyExternalID", null);
            rvrGuiltyRow.set("GuiltyPartyID", null);
            rvrGuiltyRow.set("GuiltyPartyINN", null);
            rvrGuiltyRow.set("GuiltyPartyName", createTypedField(guiltyPartyName, DotNetType.String));
            rvrGuiltyRow.set("GuiltyPartyCriteriaString", createTypedField(guiltyPartyName, DotNetType.String));
            rvrGuiltyRow.set("IsVGO", createTypedField(false, DotNetType.Boolean));
            rvrGuiltyRow.set("IsClaimDocPackage", createTypedField(false, DotNetType.Boolean));
            rvrGuiltyRow.set("IsExpensesRecharge", createTypedField(false, DotNetType.Boolean));
            rvrGuiltyRow.set("Comment", null);

            rvrGuiltyRow.state = CardRowState.Inserted;
            card.sections.get("PkAdditionalWorksContractOrderRvrGuilty")!.rows.push(rvrGuiltyRow);
        }
    }

    private GetGuiltyNameBySpecialCase(code: string | undefined) {
        if (isNullOrUndefined(code)) {
            return undefined;
        }

        const productCodes = ["1.3.2", "1.8.1", "1.8.3", "1.8.4", "1.8.5", "1.9.2"];
        if (productCodes.some(e => e === code)) {
            return "—ПРОДУКТ—";
        }

        const salesCodes = ["1.13.1", "1.13.3", "1.13.4", "1.13.5"];
        if (salesCodes.some(e => e === code)) {
            return "—ЗАКУПКИ—";
        }

        const customerCodes = ["1.1.1", "1.2.2", "1.5.2", "1.5.3", "1.5.4", "1.5.5", "1.6.1", "1.6.2", "1.6.3", "1.6.4", "1.6.5", "1.6.6", "1.6.7", "1.6.8", "1.3.1"];
        if (customerCodes.some(e => e === code)) {
            return "—ЗАКАЗЧИК—";
        }

        return undefined;
    }

    private async CheckPartnerInPerimeterAsync(partnerExternalID: number | null, аccreditationPerimetrName: string, everBeen: boolean = false) {

        if (!partnerExternalID) {
            return false;
        }

        const request = new CardRequest();
        request.requestType = CdRequestTypes.CheckPartnerInPerimeter;
        request.info["PartnerExternalID"] = createTypedField(partnerExternalID, DotNetType.Int64);
        request.info["AccreditationPerimetrName"] = createTypedField(аccreditationPerimetrName, DotNetType.String);
        request.info["EverBeen"] = createTypedField(everBeen, DotNetType.Boolean);

        const response = await CardService.instance.request(request);
        if (!response.validationResult.isSuccessful)
            return false;

        let error = response.info.Error?.$value;
        if (error) {
            await showError(error);
            return false;
        }

        let res: boolean = response.info.IsPartnerInPerimeter.$value;
        return res;
    }

    public IsNullOrZerro( value ) {
        if (PkCommonHelper.IsNullOrWhitespace(value)) return true;
        let v : number = value as number;
        if (v === 0)
            {return true;}
        if (v == 0)
            {return true}
        return false;
    }
    public finalized() {
        // подчищаем за собой
        if (this._disposer) {
            this._disposer();
            this._disposer = null;
        }
    }
}